module.exports = __webpack_public_path__ + "img/t4-i18.f31db83f.jpg";